export enum Collections {
    BRANDS = "brands",
    CARS = "cars",
    USERS = "users",
    USERS_PRIVATE_INFO = "users_private_info",
    USERS_ROLES = "users_roles",
    LEAGUES = "leagues",
    CHAMPIONSHIPS = "championships",
    CHAMPIONSHIP_DRIVERS = "championship_drivers",
    ROUNDS = "rounds",
    RACES = "races",
    RACES_CONTROL = "races_control",
    INCIDENTS = "incidents",
    BROADCAST_MESSAGES = "broadcast_messages",
    INFRACTIONS = "infractions",
    PROTESTS = "protests",
    INCIDENT_REVIEW_REQUESTS = "incident_review_requests",
    SEASONS = "seasons",
    STORAGE_FILES = "storage_files",
    TRACKS = "tracks",
    POINTS_BY_RACE_CONFIG = "points_by_race_config",
    PENALTY_POINTS = "penalty_points",
}
